import { render, staticRenderFns } from "./KeyInspector.vue?vue&type=template&id=6bb12666&scoped=true"
import script from "./KeyInspector.vue?vue&type=script&lang=js"
export * from "./KeyInspector.vue?vue&type=script&lang=js"
import style0 from "./KeyInspector.vue?vue&type=style&index=0&id=6bb12666&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb12666",
  null
  
)

export default component.exports